"use strict";
import n from "./index.es144.js";
import s from "./index.es348.js";
function f(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function u(e, i, t) {
  if (!i)
    return e;
  const a = t && t.encode || f;
  n.isFunction(t) && (t = {
    serialize: t
  });
  const r = t && t.serialize;
  let o;
  if (r ? o = r(i, t) : o = n.isURLSearchParams(i) ? i.toString() : new s(i, t).toString(a), o) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
export {
  u as default
};
//# sourceMappingURL=index.es260.js.map
